import { motion } from "motion/react"
import { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";

export default function PageFive() {
    const step = useSteppingInterval(3000, 5);

    return (
        <motion.div
        className="mainScrollBaseContainer"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -50 }}
        transition={{ duration: 0.5 }}
        >
            <div className="centered main heightCenter">
                <div className="centered">
                    <div className="featureCard flexible">
                        <FormattedMessage id="syncSummary"/><br/>
                        <FormattedMessage id="syncSummary2"/>
                    </div>
                    
                    <div className="network featureCard">
                        <div className="cell-left">
                            <span className="mdi mdi-cellphone icon"></span>
                        </div>
                        <div/><div/><div/>
                        <div className="cell-right">
                            <span className="mdi mdi-cellphone icon"></span>
                        </div>

                        <div/><div/>
                        <div className="cloud">
                            <span className="mdi mdi-cloud-outline icon"></span>
                        </div>
                        <div/><div/>

                        <div className="desktop-left">
                            <span className="mdi--desktop-windows"></span>
                        </div>
                        <div/><div/><div/>
                        <div className="desktop-right">
                            <span className="mdi--desktop-windows"></span>
                        </div>

                        <div className={"file doAnimation tr pos"+step}>
                            <span className="mdi mdi-file-lock-outline"></span>
                        </div>
                        <div className={"file doAnimation br pos"+step}>
                            <span className="mdi mdi-file-lock-outline"></span>
                        </div>
                        <div className={"file doAnimation bl pos"+step}>
                            <span className="mdi mdi-file-lock-outline"></span>
                        </div>
                        <div className="top-left">
                            <div className="long-arrow"/>
                            <div className={(step === 2) ? "long-arrow inverted active" : "long-arrow inverted"}/>
                        </div>
                        <div className="top-right">
                            <div className="long-arrow"/>
                            <div className={(step === 4) ? "long-arrow inverted active" : "long-arrow inverted"}/>
                        </div>
                        <div className="bottom-left">
                            <div className="long-arrow inverted"/>
                            <div className={(step === 4) ? "long-arrow active" : "long-arrow"}/>
                        </div>
                        <div className="bottom-right">
                            <div className="long-arrow"/>
                            <div className={(step === 4) ? "long-arrow inverted active" : "long-arrow inverted"}/>
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}

function useSteppingInterval(interval, maxSteps) {
    const [step, setStep] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
        setStep(prev => {
            return prev === maxSteps ? 0 : prev + 1;
        });
    }, interval);

    return () => clearInterval(timer);
    }, [interval, maxSteps]);

    return step;
}